import { t } from "i18next";
import React from "react";

export const getVisibleContractors = (contractorsMap) => {
  return Object.values(contractorsMap)
    .map((contractor) => ({
      ...contractor,
      contracts: contractor.contracts.filter(
        (contract) => (contract.documentsDue?.length ?? 0) > 0
      ),
    }))
    .filter((contractor) => contractor.contracts.length > 0);
};

export const DocsDueContractsByContractorSection = ({
  title,
  contractorsMap,
  contractorTypeLabel,
}) => {
  const visibleContractors = getVisibleContractors(contractorsMap);

  if (!visibleContractors.length) {
    return null;
  }

  const resourceTypeLabel = {
    E: t("EMP"),
    V: t("VEH"),
    C: t("CONT"),
  };

  const colorRes = (res) => {
    const keyword = res.toUpperCase();
    const colors = {
      E: "new-orange-bg",
      V: "new-orange-bg",
      C: "gray-800-bg",
    };
    return colors[keyword];
  };

  return (
    <div className="col">
      <h5 className="fw-bold mb-2">{title}</h5>

      <div className="d-flex flex-column gap-3">
        {visibleContractors.map((contractor) => (
          <div key={`${title}-${contractor.contractorName}`}>
            <h6 className="m-0 blue-dark-text fw-bold">
              {contractorTypeLabel}: {contractor.contractorName}
            </h6>

            <div className="d-flex flex-column gap-2 mt-2 ps-3">
              {contractor.contracts.map((contract) => (
                <div key={contract.id} className="border rounded p-2 bg-white">
                  <span className="fw-semibold">
                    {t("CONTRACT")}: {contract.contractCode} -{" "}
                    {contract.contractDescription}
                  </span>

                  <div className="d-flex flex-column gap-1">
                    {contract.documentsDue.map((document, index) => {
                      const isContractorDoc = document?.resource_type === "C";
                      const docContractorName =
                        isContractorDoc && document?.contractor_name
                          ? document.contractor_name
                          : null;
                      return (
                        <div
                          key={`${contract.id}-${document.document_code}-${
                            docContractorName || ""
                          }-${index}`}
                          className="d-flex flex-row align-items-start gap-2"
                        >
                          <div className="flex-grow-1 min-w-0 text-start">
                            <strong className="blue-text">
                              {document.document_code}
                            </strong>{" "}
                            - {document.document_desc}
                            {docContractorName ? (
                              <span className="fw-bold">
                                {" "}
                                ({docContractorName})
                              </span>
                            ) : null}
                          </div>
                          <div className="d-flex flex-shrink-0 align-items-center justify-content-center">
                            <div
                              className={`d-flex align-items-center justify-content-center tablet-color ${
                                document.resource_type
                                  ? colorRes(document.resource_type)
                                  : ""
                              }`}
                            >
                              <span
                                className="m-0"
                                style={{ color: "var(--white)" }}
                              >
                                {resourceTypeLabel[document.resource_type] ||
                                  document.resource_type}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
